<template>

      <div style="width:50rem;">
      <div class="flex justify-between">

       <div>
            <el-input size="small" v-model="keywords" placeholder="输入单号|卡号查询" style="width:15rem;" maxlength="30" clearable /> <el-button  color="#626aef" plain @click="searchKeywordsFun" size="small" >查询</el-button>
       </div>
            <el-pagination sm layout="prev, pager, next"
            :page-size="pageSize" :current-page="currentPage" :total="total" v-if="total>0" @current-change="directPage"
            > </el-pagination>

      </div>
            <div  style="height:20rem;" class="mt-2">

 <el-empty description="记录列表为空" v-if="recordList.length==0"></el-empty>

         <template v-for="(record,idx) in recordList">

          <div class=" border-2 w-80 pl-1 pr-1 pt-1 pb-1 float-left mr-2 mb-2 h-96 relative">
              <div class="text-center text-lg">{{record.sub_title}}</div>
              <div class="m-2 text-sm">
                  <span class=" text-gray-400">单号</span>
                  <span class="pl-1">{{record.bill_id}}</span>
              </div>
              <div class="m-2 text-sm">
                  <span class=" text-gray-400">时间</span>
                  <span  class="pl-1">{{record.oper_time}}</span>
              </div>
                <div class="m-2 text-sm">
                  <span class=" text-gray-400">收银</span>
                  <span  class="pl-1">{{record.oper_user_name}}</span>
              </div>
               <div class="m-2 text-sm">
                  <span class=" text-gray-400">提成</span>
                  <span  class="pl-1">{{record.award_user_name}}</span>
              </div>
               <div class="m-2 text-sm">
                  <span class=" text-gray-400">卡号</span>
                  <span  class="pl-1">{{record.card_code}}</span>
              </div>

                <div class="m-2 text-sm">
                  <span class=" text-gray-400">方式</span>
                  <span  class="pl-1" v-for="pay in record.payment_list">{{pay.payment_name}}({{pay.payment_amount.toFixed(2)}})</span>
              </div>
              <div class="m-2 text-sm">
                  <span class=" text-gray-400">实收</span>
                  <span  class="pl-1">{{record.real_amount}}</span>
              </div>
            <div class="m-2 text-sm flex h-36 " >
                  <span class=" text-gray-400">说明</span>
                  <p class="pl-1 break-words break-all overflow-y-auto w-60">
                      <span  v-for="(goods,idx2) in record.goods_list">
                          {{goods.goods_name}}({{goods.num}}{{goods.unit_name}})<br/>
                      </span>
                  </p>
              </div>

                <div class="flex items-center justify-between px-5 py-3 absolute bottom-0 w-full text-lg">

                    <div class=" cursor-pointer text-yellow-700"  @click="redWriteFun(record.bill_id)" v-if="record.redwrite_id=='0'" >
                         <i class="iconfont icon-guanbi"></i>
                         <span  class="pl-1">红冲</span>
                     </div>
                     <div class=" text-sm text-yellow-700"  v-if="record.redwrite_id!='0'" >
                       {{record.redwrite_id==record.bill_id?'已红冲':'红冲'+record.redwrite_id}}
                     </div>

                    <div class=" cursor-pointer text-gray-700" @click="printAgain(record.print_id)">
                    <i class="iconfont icon-dayin"></i>
                    <span class="pl-1">打印</span>
                    </div>
                </div>

          </div>

          </template>

            </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getRecordList, operRedWrite } from '@/utils/record.js'
import { noticePrint } from '@/utils/pos.js'
export default {
  name: 'n06',
  setup () {
    const keywords = ref('')
    const recordList = ref([])

    const pageSize = ref(2)
    const currentPage = ref(1)
    const total = ref(0)

    const directPage = (idx) => {
      currentPage.value = idx
      searchFun()
    }
    const searchFun = () => {
      getRecordList(6, {
        keywords: keywords.value.replace(/\s+/g, ''),
        offset: currentPage.value,
        limit: pageSize.value
      }, (res) => {
        total.value = res.total
        recordList.value = res.rows
      })
    }
    const searchKeywordsFun = () => {
      currentPage.value = 1
      searchFun()
    }

    const printAgain = (print_id) => {
      noticePrint(print_id, () => {
        ElMessage({
          showClose: true,
          message: '打印请求成功',
          type: 'success'
        })
      })
    }

    const redWriteFun = (billID) => {
      ElMessageBox.confirm(
        '是否确定红冲记录' + billID + '?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }
      ).then(() => {
        operRedWrite(6, {
          flag: 0,
          bill_id: billID
        }, () => {
          ElMessage({
            showClose: true,
            message: '记录红冲成功',
            type: 'success'
          })
          setTimeout(() => {
            searchKeywordsFun()
          }, 1000)
        })
      })
    }

    searchFun()

    return {
      recordList,
      pageSize,
      total,
      currentPage,
      directPage,
      searchFun,
      searchKeywordsFun,
      keywords,
      printAgain,
      redWriteFun
    }
  }
}
</script>
<style scoped>

</style>
